import React from 'react';
import BsModal from '../../Common/BsModal';
import FeesGroupStructure from '../../../RightBar/SchoolFees/FeesGroupStructure';

const ManageStructureModal = ({onClose, show, structure}) => {
    return (
        <BsModal
            show={show}
            onClose={onClose}
            title="Manage Fees Structure"
            size="modal-lg"
            footer={
                <>
                {/* <button type="button" className="btn btn-light" onClick={onClose}>
                    Close Manager
                </button> */}
            
                </>
            }
        >

        {structure && (<FeesGroupStructure feesGroup={structure} />)}
            
        </BsModal>
    );
};

export default ManageStructureModal;